import axios from 'axios';
import qs from 'qs';
import localStorage from 'store';
import notification from 'ant-design-vue/es/notification'

const request = axios.create({
    // API请求的默认前缀
	// baseURL: 'http://adminapi.kuaiqian.com/', // 本地
	baseURL: 'https://adminapi.love1234.com', // 线上
    // baseURL: '/api', // 开发
    // 3秒超时
    timeout: 30000,
});

function requestGet(url, params) {
    if (params && Object.keys(params).length !== 0) {
        url += '?' + qs.stringify(params);
        console.log('url:' + url);
    }
    return request({
        url: url,
        method: 'GET'
    });
}

function requestPost(url, params) {
    console.log('url:' + url);
    params = params && qs.stringify(params);
    return request({
        url: url,
        method: 'POST',
        data: params,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
    });
}

function requestUpload(url, form) {
    return request({
        url: url,
        method: 'POST',
        headers: {},
        params:{},
        data: form
    });
}

// 错误处理
const errorHandler = (error) => {
    if (error.response) {
        if (error.response.status === 403) {
            notification.error({
                message: '权限不足',
                description: '你没有该权限'
            });
        } else if(error.response.status === 404) {
            notification.error({
                message: '404',
                description: '资源不存在'
            });
        } else if(error.response.status === 401) {
            const token = localStorage.get('admin.token');
            notification.error({
                message: '未登录',
                description: '你还没有登录，或登录已过期'
            });

            if(token) {
                removeToken();
                setTimeout(() => {
                    window.location.reload();
                });
            }
        } else if(error.response.status === 500) {
            console.error(error.response.data);
        }
    }
    return Promise.reject(error);
}

// 请求拦截器
request.interceptors.request.use(config => {
    const token = localStorage.get('admin.token');
    if(token) {
        config.headers['token'] = token;
    }
    return config;
}, errorHandler)

// 响应拦截器
request.interceptors.response.use((response) => {
    let res = response.data;
    res.isSucceed = (res.code == '200') ? true : false;
    return res;
}, errorHandler);

function setToken(token) {
    localStorage.set('admin.token', token);
}

function checkToken() {
    return localStorage.get('admin.token') ? true : false;
}

function removeToken() {
    return localStorage.remove('admin.token');
}

export {
    request,
    requestGet,
    requestPost,
    requestUpload,
    setToken,
    checkToken,
    removeToken
}
